import React from 'react'
import { withRouter } from "react-router-dom";
import Editmoveform from './components/Editmoveform'
 function Editmovesize() {
    return (
       <Editmoveform></Editmoveform>
    )
}
export default withRouter(Editmovesize);
